import { AppRoutePaths } from '@/routing/route_paths'
import useStudenDetailsDocumentParams from '../hooks/useStudentDetailsDocumentParams'
import { useTranslation } from 'react-i18next'
import { CaptureInstructions } from './CaptureInstructions'
import { useTypesafeStudent } from '../useTypesafeStudent'

export const SpecialEducationCaptureInstructions = () => {
  const { fullName } = useTypesafeStudent()
  const { t: translate } = useTranslation()
  const { info, onRouteChange } = useStudenDetailsDocumentParams()
  const { index:document_type, document_capture } =
    AppRoutePaths.family_application.student_details.special_education

  const selectedForm = info()

  function handleContinueClick() {
    onRouteChange(document_capture)
  }

  function handleCantFindClick() {
    onRouteChange(document_type)
  }

  return (
    <>
      <h1 className="text-3xl text-center font-medium text-gray-900 mb-10 sm:mb-5">
        {translate('special_education_verification')}
      </h1>

      <h2 className="text-center text-xl text-gray-900 my-10 mb-3 sm:mb-2">
        {translate('we_need_a_picture_of_your_special_education_form').replace(':student_name', fullName)}.
      </h2>

      <div className="flex justify-center">
        <img alt={translate('special_education')} src={selectedForm.image} className=" h-60 shadow-md" />
      </div>

      <CaptureInstructions 
        name={selectedForm.longName}
        onCantFindClick={handleCantFindClick}
        onContinueClick={handleContinueClick}
      />
    </>
  )
}
